module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-4@3x.c5275df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-4@3x.png
// module id = Cao+
// module chunks = 18